import { render, staticRenderFns } from "./businessIndicatorsNY.vue?vue&type=template&id=dd52e476&scoped=true"
import script from "./businessIndicatorsNY.vue?vue&type=script&lang=js"
export * from "./businessIndicatorsNY.vue?vue&type=script&lang=js"
import style0 from "./businessIndicatorsNY.vue?vue&type=style&index=0&id=dd52e476&prod&lang=scss&scoped=true"
import style1 from "./businessIndicatorsNY.vue?vue&type=style&index=1&id=dd52e476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd52e476",
  null
  
)

export default component.exports